module.exports = __webpack_public_path__ + "img/58.64f61f1.jpg";